import {
  BlueprintSingleConditionValue,
  ComparisonOperators,
  ConditionBlueprintType,
  DateUnits,
  MatchesConditionPropertyQuantifiers,
  MathConditionOperators,
  NumberComparisonConditionOperators,
  YesNoValues,
} from '@zinnia/form-engine-sdk';

const DEFAULT_NODE_ID = '';

export function getEmptyStateForConditionType(type: ConditionBlueprintType): BlueprintSingleConditionValue {
  switch (type) {
    case ConditionBlueprintType.ageRange: {
      return {
        type: ConditionBlueprintType.ageRange,
        value: {
          minAge: 0,
          maxAge: 99,
          unit: DateUnits.year,
        },
        targetBirthdateNodeId: DEFAULT_NODE_ID,
      };
    }
    case ConditionBlueprintType.context: {
      return {
        type: ConditionBlueprintType.context,
        left: {
          namespace: 'namespace',
          query: {
            type: 'JsonPath',
            jsonPath: '&.isSmoker',
          },
        },
        operator: '<',
        right: {
          type: 'Literal',
          value: 50000,
        },
      };
    }
    case ConditionBlueprintType.bmiRange: {
      return {
        type: ConditionBlueprintType.bmiRange,
        value: {
          minBMI: 18,
          maxBMI: 35,
        },
        heightNodeId: DEFAULT_NODE_ID,
        weightNodeId: DEFAULT_NODE_ID,
        heightUnit: 'inch',
        weightUnit: 'lb',
      };
    }
    case ConditionBlueprintType.characterCountInBetween: {
      return {
        type: ConditionBlueprintType.characterCountInBetween,
        value: {
          minLength: 1,
        },
        targetNodeId: DEFAULT_NODE_ID,
      };
    }
    case ConditionBlueprintType.countEqual: {
      return {
        type: ConditionBlueprintType.countEqual,
        targetNodeId: DEFAULT_NODE_ID,
        controlValue: 'no',
        operator: NumberComparisonConditionOperators.greaterThan,
        value: 0,
      };
    }
    case ConditionBlueprintType.dateComparison: {
      return {
        type: ConditionBlueprintType.dateComparison,
        startDateNodeId: DEFAULT_NODE_ID,
        endDateNodeId: DEFAULT_NODE_ID,
        operator: NumberComparisonConditionOperators.lessThan,
        value: 0,
        unit: DateUnits.year,
      };
    }
    case ConditionBlueprintType.emptiness: {
      return {
        type: ConditionBlueprintType.emptiness,
        isEmpty: true,
        targetNodeId: DEFAULT_NODE_ID,
      };
    }
    case ConditionBlueprintType.engineCondition: {
      return {
        type: ConditionBlueprintType.engineCondition,
        condition: {
          operator: ComparisonOperators.equal,
        },
      };
    }
    case ConditionBlueprintType.equality: {
      return {
        type: ConditionBlueprintType.equality,
        value: '',
        isEqual: true,
        targetNodeId: DEFAULT_NODE_ID,
      };
    }
    case ConditionBlueprintType.futureDate: {
      return {
        type: ConditionBlueprintType.futureDate,
        value: 0,
        targetNodeId: DEFAULT_NODE_ID,
        unit: DateUnits.year,
        operator: NumberComparisonConditionOperators.lessThan,
      };
    }
    case ConditionBlueprintType.instancesCount: {
      return {
        type: ConditionBlueprintType.instancesCount,
        nodeIdsToAdd: [],
        nodeIdsToSubtract: [],
      };
    }
    case ConditionBlueprintType.jointProductAgeRange: {
      return {
        type: ConditionBlueprintType.jointProductAgeRange,

        jointProductNodeIds: [],
        insuredBirthdayNodeId: DEFAULT_NODE_ID,
        repeatableInsuredCollectionId: DEFAULT_NODE_ID,
        value: {
          maxAge: 0,
          unit: DateUnits.year,
        },
      };
    }
    case ConditionBlueprintType.lastIncidentDate: {
      return {
        type: ConditionBlueprintType.lastIncidentDate,
        value: 0,
        targetNodeId: DEFAULT_NODE_ID,
        unit: DateUnits.year,
        operator: NumberComparisonConditionOperators.lessThan,
      };
    }
    case ConditionBlueprintType.matches: {
      return {
        type: ConditionBlueprintType.matches,
        value: [],
        targetNodeId: DEFAULT_NODE_ID,
        quantifier: MatchesConditionPropertyQuantifiers.any,
      };
    }
    case ConditionBlueprintType.matchesRegex: {
      return {
        type: ConditionBlueprintType.matchesRegex,
        targetNodeId: DEFAULT_NODE_ID,
        regex: '',
      };
    }
    case ConditionBlueprintType.luhnCheck: {
      return {
        type: ConditionBlueprintType.luhnCheck,
        targetNodeId: DEFAULT_NODE_ID,
      };
    }
    case ConditionBlueprintType.mathOperator: {
      return {
        type: ConditionBlueprintType.mathOperator,
        value: 0,
        nodeIds: [],
        operator: NumberComparisonConditionOperators.greaterThan,
        mathOperator: MathConditionOperators.sum,
      };
    }
    case ConditionBlueprintType.numberComparison: {
      return {
        type: ConditionBlueprintType.numberComparison,
        value: 0,
        targetNodeId: DEFAULT_NODE_ID,
        operator: NumberComparisonConditionOperators.greaterThan,
      };
    }
    case ConditionBlueprintType.percentOf: {
      return {
        type: ConditionBlueprintType.percentOf,
        targetNodeId: DEFAULT_NODE_ID,
        percent: 100,
        operator: NumberComparisonConditionOperators.lessThanOrEqual,
        value: 0,
      };
    }
    case ConditionBlueprintType.reflexive: {
      return {
        type: ConditionBlueprintType.reflexive,
        value: YesNoValues.yes,
        targetNodeId: DEFAULT_NODE_ID,
      };
    }
  }
}

export const defaultSingleConditionBlueprintValue = (): BlueprintSingleConditionValue =>
  getEmptyStateForConditionType(ConditionBlueprintType.reflexive);
